import SummaryContentBox from './summaryContentBox.js';
export default SummaryContentBox;
